import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import * as EquipmentType from '../../Store/AssetManagement/Equipment/EquipmentType'
import { setEquipmentType } from '../../Store/AssetManagement/Equipment/EquipmentAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getEquipmentTypes(assetSubType: any): any {
    let payloadData : IPayload = {
        apiType : apiType.AssetManagement,
        endpoint : `assets/dropdown/assetsubtypes/${assetSubType.assetSubTypeId}`,
        apiMethod : apiMethod.GET,
        payload : null
    }
    try {
        yield put(globalLoaderText("Fetching Equipment Types...."));

        const response = yield call(
            AssetManagementApiService.post,API_URL.PostWebApp,payloadData
            
        );
        if(response?.length > 0){
            const defaultEquipmentTypeOption = {
                text: "Select Equipment Type",
                value: null
            };
            response.unshift(defaultEquipmentTypeOption);
        }
        yield put({
            type: EquipmentType.SAVE_EQUIPMENT_TYPE,
            equipmentType: response
        })
        yield put(setEquipmentType(response));
        yield put(globalLoaderText(""));

    } catch (error) {
        yield put({
            type: EquipmentType.SAVE_EQUIPMENT_TYPE,
            equipmentType: []
        })
        yield put(globalLoaderText(""));
    }
}

function* watchGetEquipmentTypes() {
    yield takeEvery(EquipmentType.GET_EQUIPMENT_TYPE, getEquipmentTypes)
}

export default function* combinedSaga() {
    yield all([
        watchGetEquipmentTypes()
    ])
}
